import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { Comparison } from 'app/providers/bridge-api/dashboard.service';

import {
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { DriverTableComponent } from '../driver-table/driver-table.component';
import { WidgetPredictiveOptions } from '../widget-predictive/widget-predictive.component';
import { Breakdown, Driver } from '../../models/predictive.models';

@Component({
  selector: 'app-predictive-driver-widgetette',
  imports: [AppSharedModule, DriverTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './predictive-driver-widgetette.component.html',
  styleUrl: './predictive-driver-widgetette.component.scss',
})
export class PredictiveDriverWidgetetteComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  readonly breakdown = input<Breakdown>(null);
  readonly predictiveOptions = input.required<WidgetPredictiveOptions>();
  readonly isReadOnly = input.required<boolean>();
  readonly isDashboardLocked = input.required<boolean>();
  readonly comparison = input<Comparison>();

  hoverDriver = output<Driver | null>();
  simulateDriver = output<Driver>();
  resetDriver = output<Driver>();
  smartSummaryDriver = output<Driver>();

  drivers = computed(() => this.breakdown()?.drivers ?? []);

  onHoverDriver(driver: Driver | null): void {
    this.hoverDriver.emit(driver);
  }
  onSimulateDriver(driver: Driver | null): void {
    this.simulateDriver.emit(driver);
  }
  onResetDriver(driver: Driver | null): void {
    this.resetDriver.emit(driver);
  }
  onSmartSummaryDriver(driver: Driver | null): void {
    this.smartSummaryDriver.emit(driver);
  }
}
